/** ESCHER FALLS — Русский。 */

import type { Strings } from './ja';

export const RU: Strings = {
  pour: 'Пустить',
  lever: 'Рычаг',
  leverAria: 'Опустить рычаг',
  retry: 'Заново',
  again: 'Ещё раз',
  next: 'Дальше',
  share: 'Отправить этот снимок',
  shareFailed: 'Не удалось отправить',
  rotateLeft: 'Повернуть вид влево',
  rotateRight: 'Повернуть вид вправо',
  tiltUp: 'Поднять вид',
  tiltDown: 'Опустить вид',
  topDown: 'Сверху',
  water: (left, total) => `Вода ${left} / ${total}`,
  moves: (left, total) => `Ходы ${left} / ${total}`,
  timeLeft: (time) => `Осталось ${time}`,
  drops: (n) => `Капли: ${n}`,

  resultClear: 'Прошла',
  resultFail: 'Не прошла',
  clearTitle: 'Вода прошла',
  fail: {
    time: 'Время вышло',
    moves: 'Ходы закончились',
    drywell: 'Вода ушла в сухой колодец',
    water: 'Вода закончилась',
    deadend: 'Вода упала в тупик',
  },
  extendByAd: 'Посмотреть рекламу и получить 30 секунд',
  extendByDrops: (cost) => `${cost} капель за 30 секунд`,
  multiplyByAd: (mult) => `Реклама за ×${mult} капель`,

  stages: 'Уровни',
  settingsAria: 'Настройки',
  menuAria: 'Меню',
  back: 'Назад',
  loop1: 'Первый круг',
  loop2: 'Второй круг',
  loopNote: 'На втором круге меньше ходов и времени. Записи хранятся отдельно.',
  shop: 'Магазин',
  groupMain: 'Основные',
  groupExtra1: 'Дополнение',
  groupExtra2: 'Дополнение II',
  freeTrial: 'Бесплатно',
  notPurchased: (n, name) => `${n} ${name} (закрыт)`,
  lockedStage: 'Закрытый уровень',
  extraLockedFree: 'Уровень 1, «Водопад наоборот», бесплатный. Остальные открываются покупкой в Настройках (≡).',
  extraLocked: 'Открывается покупкой в Настройках (≡).',
  extra2Locked: 'С 11-го уровня откроется, когда вода пройдёт по уровням 1–10.',
  extra2LockedUnowned: 'Купите в Настройках (≡) и пройдите уровни 1–10, чтобы открыть уровни с 11-го.',
  extra2Note: 'Откроется, когда вода пройдёт по всем дополнительным уровням.',
  progress: (cleared, total) => `Основные ${cleared} / ${total} пройдено`,
  totalTime: (time) => `Всего ${time}`,
  totalNone: 'Всего —',

  settings: 'Настройки',
  bgm: 'Фон',
  se: 'Звуки',
  testSound: 'Проверить звук',
  audioStatus: (state) => `Звук: ${state}`,
  audioState: {
    locked: 'Не включён (коснитесь экрана один раз)',
    running: 'Работает',
    suspended: 'Приостановлен',
  },
  demoNote: (n) => `Эти ${n} уровней — веб-демо. Все 42 — в приложении.`,
  demoGet: 'Скачать в App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Уровень дня',
  dailyLoading: 'Загрузка…',
  dailyOffline: 'Нет связи — уровень дня не открыть',
  dailyPlay: 'Играть',
  dailyCleared: (time: string) => `Пройдено за ${time}`,
  archiveTitle: 'Прошлые уровни',
  upcomingTitle: 'Будущие уровни',
  archiveLocked: 'Последние 3 дня бесплатны. Купите Дополнение, чтобы открыть все более ранние',
  language: 'Язык',
  languageAuto: 'Как на устройстве',
  palette: 'Палитра',
  worn: 'Выбрана',
  owned: 'Есть',
  buyDrops: 'Купить капли',
  restore: 'Восстановить покупки',
  writeReview: 'Оценить это приложение',
  moreApps: 'Другие работы автора',
  restoreChecking: 'Проверяем…',
  restoreDone: (n) => `Восстановлено: ${n}`,
  restoreNone: 'Восстанавливать нечего',
  restoreFailed: 'Не удалось восстановить',
  chooseStage: 'Выбрать уровень',
  resume: 'Продолжить',

  prizeLabel: 'Награда',
  awardLabel: 'Звание',
  toExtra: 'К дополнениям',
  toLoop2: 'Ко второму кругу',
  toStart: 'К началу',
  allClearTitle: 'Пройдено всё',
  allClearBody: (n) => `Вода прошла по всем ${n} каналам`,
  multiplyTimes: (mult) => `Реклама за ×${mult}`,
  noteRank: 'Звание остаётся в записях и показывается над списком уровней.',
  noteLoop2: 'Второй круг открыт. Ходов и времени меньше.',
  notePartOne: 'На этом первая часть. Вода ещё не поднималась.',
  inviteTry: 'Попробовать дополнение 1',
  inviteOpen: 'Открыть Дополнение I — 20 уровней',
  dateLine: (d) =>
    `${d.getDate()} ${['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'][d.getMonth()]} ${d.getFullYear()}`,

  completionTitle: 'Прошедший бесконечное',
  rank: {
    none: '—',
    sovereign: 'Владыка воды',
    architect: 'Зодчий водопадов',
    mason: 'Каменщик',
    apprentice: 'Ученик',
    wayfarer: 'Путник',
  },

  skin: {
    hakushi: 'Чистая бумага',
    ai: 'Индиго',
    koke: 'Мох',
    shu: 'Киноварь',
    sumi: 'Тушь суми',
  },

  product: {
    drops600: '600 капель',
    drops1600: '1 600 капель',
    drops5000: '5 000 капель',
    noads: 'Убрать рекламу',
    extras: 'Дополнение I — 21 уровней (без рекламы)',
  },
};
